module.exports = __webpack_public_path__ + "static/media/golfBag.cb02af7e.svg";